import React, { useEffect, useState, useRef } from "react";
import HeadingComp from "../UdsEmployeeDashboard/CustomHooks/HeadingComp";
import { useDispatch, useSelector } from "react-redux";
import { setTheresignationForEmp, setTheresignationRetrieveForEmp } from "../../../../Redux/Slice"
import { store } from "../../../../Redux/Store"
import { useNavigate } from "react-router-dom";
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";

const EmpResign = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );
    const state = useSelector((state) => state)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [data, setData] = useState({
        emp_date: "",
        status: "pending",
        purpose: "",
        user_id: "",
        request_type: "request",
        leave_type: "",
        retridate: ""
    });
    const [fieldErrors, setFieldErrors] = useState({
        purpose: "",
        leave_type: "",
    });
    const [lastWorkingDate, setLastWorkingDate] = useState('');

    const calculateLastWorkingDate = (emp_date) => {
        if (emp_date && !isNaN(emp_date)) {
            const days = parseInt(emp_date, 10);
            const today = new Date();
            today.setDate(today.getDate() + days);

            // Format the date as "DD, MMM YYYY"
            const options = { day: '2-digit', month: 'short', year: 'numeric' };
            const formattedDate = today.toLocaleDateString('en-US', options);
            setLastWorkingDate(formattedDate);
        } else {
            setLastWorkingDate('');
        }
    };

    useEffect(() => {
        const payload = {
            user: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                .id
        }
        dispatch(setTheresignationRetrieveForEmp(payload))
    }, [])
    console.log(state.ResignationEmpRetrieveEmp.ResignationDataForEmpRetrieve, "ResignationDataForEmpRetrieve");
    useEffect(() => {
        if (state.ResignationEmpRetrieveEmp.ResignationDataForEmpRetrieve.length == 1) {
            setData({
                ...data,
                emp_date: state.ResignationEmpRetrieveEmp.ResignationDataForEmpRetrieve[0].emp_date,
                purpose: state.ResignationEmpRetrieveEmp.ResignationDataForEmpRetrieve[0].purpose,
                retridate: state.ResignationEmpRetrieveEmp.ResignationDataForEmpRetrieve[0].id
            })
            calculateLastWorkingDate(state.ResignationEmpRetrieveEmp.ResignationDataForEmpRetrieve[0].emp_date); // Calculate last working date based on retrieved emp_date

        }
    }, [state.ResignationEmpRetrieveEmp.ResignationDataForEmpRetrieve])

    console.log(data, "asoiduoiasud data");

    // setTheresignationRetrieveForEmp
    const inputRef = useRef(null);
    const preventZoom = (event) => {
        if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.type === "wheel")) {
            event.preventDefault();
        }

        if (["e", "E", "+", "-", "."].includes(event.key) || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
        }
    };
    const handlePaste = (event) => {
        let paste = (event.clipboardData || window.clipboardData).getData('text');
        console.log(paste, "934809paste");

        // Strip non-numeric characters (allow only digits)
        const filtered = paste.replace(/[^0-9]/g, '');

        // Prevent the default paste action and set the input value to the filtered result
        event.preventDefault();

        if (filtered.length <= 6) { // Ensure max length of 6 digits
            event.target.value = filtered;
            if (event.target.name == "emp_date") {
                HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
            }
            else {
                HandleChanges({ target: { name: event.target.name, value: filtered } });

            }
        }
    };


    const preventwheel = (event) => {
        if (event.target && event.target.className == "form-control" || event.target.class == "form-control") {
            event.preventDefault();
        }
    }



    useEffect(() => {
        const inputElement = inputRef.current;

        if (inputElement) {

            window.addEventListener("wheel", preventwheel, { passive: false });
        }
        return () => {
            window.removeEventListener("wheel", preventwheel);
        };
    }, []);

    useEffect(() => {
        const inputElement = inputRef.current;

        const preventScroll = (event) => {

            if (event.target && event.target.className == "form-control" || event.target.class == "form-control") {
                event.preventDefault();
            }
        };
        if (inputElement) {

            // Attach the listener to the window or a specific container
            window.addEventListener("wheel", preventScroll, { passive: false });
        }
        return () => {
            window.removeEventListener("wheel", preventScroll);
        };
    }, []);


    const HandleChanges = (e) => {
        const { name, value } = e.target;

        setData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (name === 'emp_date') {
            calculateLastWorkingDate(value); // Calculate date when emp_date changes
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const newFieldErrors = { ...fieldErrors };
        Object.entries(data).forEach(([key, value]) => {
            if (key === "purpose" && value.trim().length === 0) {
                newFieldErrors.purpose = "Reason must not be empty.";
            } else if (key === "emp_date" && value.trim().length === 0) {
                newFieldErrors.emp_date = "Notice Period must not be empty.";
            }
        });
        const hasError = Object.values(newFieldErrors).some((error) => error);
        setFieldErrors(newFieldErrors);
        if (!hasError) {
            const payload = {
                formData: {
                    purpose: data.purpose,
                    emp_date: data.emp_date,
                    user_id: store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.data.data
                        .id,
                }
            }
            dispatch(setTheresignationForEmp(payload));

        }
    }
    console.log(data.retridate, "data.retridate");

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>

                <div className="leaveApplyWrapper">
                    <HeadingComp english={"Resign"} hindi={"no Apply"} />
                    <div
                        className="row Filters ButtonPrevious"
                        style={{
                            padding: "3px",
                            position: "relative",
                            zIndex: "30",
                            marginLeft: "-17px",
                            marginRight: "0px",
                        }}
                    >
                        <div className="col">
                            <button
                                className="btn BackImga"
                                onClick={(e) => {
                                    navigate("/employment");
                                }}
                            >
                                <img className="PreviousPages" src={BackImage} />
                                <span></span>

                            </button>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="leaveApplyBody">
                            <div className="row">
                                <div className="col-sm-3 section1">
                                    <label htmlFor="leaveType">
                                        Reason<span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input className="form-control" type="text"
                                        value={data.purpose}
                                        readOnly={data.retridate == "" ? false : true}
                                        disabled={data.retridate == "" ? false : true}
                                        autoComplete="off"
                                        name="purpose" onChange={(e) => {
                                            HandleChanges(e);
                                            fieldErrors.purpose = "";

                                        }} />

                                    <div className="errorCheckBox">
                                        {fieldErrors.purpose && (
                                            <>
                                                {" "}
                                                <span style={{ color: "red" }}>
                                                    * {fieldErrors.purpose}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                </div>


                                <div className="col-sm-3 ">
                                    <label
                                        className=" form-label"
                                        htmlFor="to_date"
                                    >
                                        Notice Period (in Days)
                                        <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input className="form-control" type="number"
                                        name="emp_date"
                                        step="1"
                                        value={data.emp_date}
                                        disabled={data.retridate == "" ? false : true}
                                        readOnly={data.retridate == "" ? false : true}
                                        onKeyDown={preventZoom}  // Prevent zoom and unwanted keys
                                        onPaste={handlePaste}    // Handle pasting
                                        onWheel={preventZoom}    // Prevent zooming with the mouse wheel
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // Allow values only between 1 and 99
                                            const numberRegex = /^[1-9][0-9]?$/; // Allows numbers from 1 to 99 (up to 2 digits)
                                            console.log(Number(value), "oiaweoiquwoieq", value.length);

                                            if (value.length <= 2) {
                                                HandleChanges(e);
                                                fieldErrors.emp_date = "";

                                            }
                                            else {
                                                e.preventDefault(); // Prevent entering more than 2 characters
                                            }

                                        }}
                                    />
                                </div>

                                {fieldErrors.emp_date && (
                                    <>
                                        <span style={{ color: "red" }}>
                                            {fieldErrors.emp_date}
                                        </span>
                                    </>
                                )}

                                <div className="col-sm-3">
                                    <label
                                        className=" form-label"
                                        htmlFor="to_date"
                                    >
                                        Last Working Date
                                    </label>
                                    <input className="form-control" type="text" value={lastWorkingDate} readOnly disabled />
                                </div>
                            </div>
                            <div className="row ">
                                <div className=" col-12 section1 d-flex justify-content-end" style={{ paddingRight: "80px" }}>
                                    {data.retridate == "" ?
                                        <button
                                            className="customButton ButtonCSS"
                                            style={{ background: "#234492 " }}
                                        >
                                            Apply
                                        </button>
                                        : null}
                                </div>
                            </div>
                        </div>
                    </form>

                </div>
            </div>

        </>)
}

export default EmpResign